<mat-expansion-panel [expanded]="isExpanded()">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <mat-icon class="me-2">lock</mat-icon>
      {{ 'system.dialogSection.screenLock' | translate }}
    </mat-panel-title>
  </mat-expansion-panel-header>

  <div class="col-lg-12">
    <mat-dropdown
      [options]="durationOptions"
      [configurationInput]="durationDropdownConfiguration"
      [formControl]="durationControl()"
      [isFormSubmitted]="isFormSubmitted()"
    ></mat-dropdown>
  </div>

  @if (isLockEnabled()) {
    <div class="col-lg-12">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'field.autoLockPin' | translate }}</mat-label>
        <input
          matInput
          type="password"
          inputmode="numeric"
          autocomplete="new-password"
          maxlength="12"
          [formControl]="pinControl()"
          [errorStateMatcher]="pinErrorStateMatcher"
        />
        <mat-error [control]="pinControl()"></mat-error>
      </mat-form-field>
      <div class="screen-lock-hint">{{ pinHintKey() | translate }}</div>
    </div>
  } @else if (showInheritanceHint()) {
    <div class="screen-lock-hint">{{ 'page.screenLock.slideshowInheritanceHint' | translate }}</div>
  }
</mat-expansion-panel>
